// Two Decimals

export default function twoDecimal() {
	return function (input) {
		return input.toFixed(2);
	};
}